export type RouteSound = 'start' | 'turn' | 'correct' | 'wrong' | 'caught' | 'portal' | 'complete' | 'restart';

/**
 * Küçük, dosyasız ses efektleri. Ses bağlamı yalnız ilk gerçek oyuncu
 * etkileşiminde açılır; böylece tarayıcı otomatik oynatma kuralına uyulur.
 */
export class RouteAudio {
  private context?: AudioContext;
  private master?: GainNode;

  unlock() {
    if (!this.context) {
      const Context = window.AudioContext
        ?? (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Context) return;
      this.context = new Context();
      this.master = this.context.createGain();
      this.master.gain.value = 0.18;
      this.master.connect(this.context.destination);
    }
    if (this.context.state === 'suspended') void this.context.resume();
  }

  play(sound: RouteSound) {
    this.unlock();
    const context = this.context;
    const master = this.master;
    if (!context || !master || context.state !== 'running') return;
    const now = context.currentTime;
    const notes: Record<RouteSound, readonly number[]> = {
      start: [392, 523],
      turn: [440],
      correct: [523, 659, 784],
      wrong: [220, 175],
      caught: [196, 147, 110],
      portal: [330, 494, 660],
      complete: [523, 659, 784, 1047],
      restart: [392, 523, 659],
    };
    const type: OscillatorType = sound === 'caught' || sound === 'wrong' ? 'sawtooth' : 'triangle';
    notes[sound].forEach((frequency, index) => {
      const beginsAt = now + index * (sound === 'turn' ? 0 : 0.075);
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      const filter = context.createBiquadFilter();
      oscillator.type = type;
      oscillator.frequency.setValueAtTime(frequency, beginsAt);
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(sound === 'caught' ? 950 : 2800, beginsAt);
      gain.gain.setValueAtTime(sound === 'turn' ? 0.055 : 0.12, beginsAt);
      gain.gain.exponentialRampToValueAtTime(0.001, beginsAt + 0.14);
      oscillator.connect(filter).connect(gain).connect(master);
      oscillator.start(beginsAt);
      oscillator.stop(beginsAt + 0.16);
    });
  }
}
